export default "__VITE_ASSET__hWbCpFHk__"